export type OffsetCollection<T> = { total: number; data: T[] };

// URL·인증·DTO 변환은 호출자가 소유하고, 전체 목록의 완전성과 중복 여부만 검증한다.
export async function collectOffsetPages<T extends { id: string }>(
  loadPage: (offset: number) => Promise<OffsetCollection<T>>,
  pageSize = 100,
  keyOf: (item: T) => string = (item) => item.id,
): Promise<OffsetCollection<T>> {
  const data: T[] = [];
  const ids = new Set<string>();
  let expectedTotal: number | undefined;
  let offset = 0;
  let pageCount = 0;
  do {
    if (pageCount >= 1000) throw new Error('목록이 너무 커서 모두 불러오지 못했습니다. 검색 조건을 좁혀 주세요.');
    const page = await loadPage(offset);
    pageCount += 1;
    if (!Number.isInteger(page.total) || page.total < 0) throw new Error('목록의 전체 개수를 확인하지 못했습니다. 다시 시도해 주세요.');
    if (expectedTotal === undefined) expectedTotal = page.total;
    else if (page.total !== expectedTotal) throw new Error('목록을 불러오는 동안 데이터가 변경되었습니다. 다시 시도해 주세요.');
    if (page.data.length > pageSize) throw new Error('목록 페이지의 크기가 일치하지 않습니다. 다시 시도해 주세요.');
    if (page.data.length === 0 && data.length < expectedTotal) throw new Error('목록의 일부를 불러오지 못했습니다. 다시 시도해 주세요.');
    for (const item of page.data) {
      const key = keyOf(item);
      if (ids.has(key)) throw new Error('목록에서 중복된 항목을 받았습니다. 다시 시도해 주세요.');
      ids.add(key);
      data.push(item);
    }
    if (data.length > expectedTotal) throw new Error('목록의 전체 개수가 일치하지 않습니다. 다시 시도해 주세요.');
    offset += page.data.length;
  } while (data.length < (expectedTotal ?? 0));
  return { total: expectedTotal ?? 0, data };
}
